module.exports = __webpack_public_path__ + "img/globe-nav-chevron-right-dent-red.89c3f619.svg";